import { render, staticRenderFns } from "./kamitakuLtv.vue?vue&type=template&id=3820c48e&scoped=true&"
import script from "./kamitakuLtv.vue?vue&type=script&lang=js&"
export * from "./kamitakuLtv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820c48e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3820c48e')) {
      api.createRecord('3820c48e', component.options)
    } else {
      api.reload('3820c48e', component.options)
    }
    module.hot.accept("./kamitakuLtv.vue?vue&type=template&id=3820c48e&scoped=true&", function () {
      api.rerender('3820c48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kamitaku/kamitakuLtv.vue"
export default component.exports